// extracted by mini-css-extract-plugin
export default {"basePadding":"BasePadding_basePadding__24+Sl"};